import {useEffect, useState} from 'react'

function useNavActive(
  elementsId: string[]
) {
  // elementsId.reverse()
  const [activeIdx, setActiveIdx] = useState<number>(0);

  const currentId = () => {
    let currEl = elementsId.filter( (el)=>{
      const top = document.getElementById(el)?.offsetTop
      // console.log(`${window.scrollY} | ${el}: ${top} `)
      return top !== undefined && window.scrollY+50 > top
    } ).at(-1)
    // console.log(`active ${currEl}`)
    if (currEl) setActiveIdx( elementsId.indexOf(currEl) )
  }

  useEffect(() => {
    window.addEventListener('scroll', currentId);
    return () => window.removeEventListener('scroll', currentId);
  },[]);

  return activeIdx
}

export default useNavActive